const middleware = {}

middleware['router-middleware'] = require('../middleware/router-middleware.js')
middleware['router-middleware'] = middleware['router-middleware'].default || middleware['router-middleware']

export default middleware
